import React, {useEffect, useState} from "react";


import {
    RefundOptionsCategoriesObject,
    UserSubmitRequestDataInterface
} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";


import {
    Row, Col
} from "react-bootstrap";


import {
    ButtonComponent
} from "@Components/Forms";

import {
    CheckboxFieldComponent
} from "@Elements";


import IconArrowLeftSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_left-sm-brown.svg";
import IconArrowRightSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_right-sm-brown.svg";
import IconCheckboxCheckedSmGreen from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps//@Icons/icon-checkbox_checked-sm-green.svg";
import IconCheckboxUncheckedSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps//@Icons/icon-checkbox_unchecked-sm-grey.svg";
import {SvgIconComponent} from "@Components/Elements";

import IconArrowDownSmGrey from "./icon-arrow_down-sm-grey.svg";
import IconArrowUpSmGrey from "./icon-arrow_up-sm-grey.svg";


import "./index.scss";


interface UserDashboardSubmitRequestStep1ComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestDataSetter: (userSubmitRequestData: UserSubmitRequestDataInterface) => void;
}


export const UserDashboardSubmitRequestStep1Component:React.FC<UserDashboardSubmitRequestStep1ComponentProps> = ({
    userSubmitRequestStepSetter,
    userSubmitRequestData, userSubmitRequestDataSetter
}) => {

    const [activeRefundCategoryId, setActiveRefundCategoryId] = useState(0);

    useEffect(() => {
        return () => {
            setActiveRefundCategoryId(0);
        };
    }, []);

    const { refundOptionsStep: storedRefundOptions } = userSubmitRequestData;

    const checkedRefundOptions = new Set<number>(storedRefundOptions);


    const refundOptionCheckedStatusHandler = (optionId: number) => {
        checkedRefundOptions.has(optionId) ?
            checkedRefundOptions.delete(optionId) : checkedRefundOptions.add(optionId)
        ;
        userSubmitRequestDataSetter(
            { ...userSubmitRequestData, refundOptionsStep: Array.from(checkedRefundOptions) }
        );
    };


    const refundOptionsCategoriesList = RefundOptionsCategoriesObject.map((refundCategory) => {

        const {
            refundOptionsCategoryId,
            refundOptionsCategoryName, refundOptionsCategoryIcon,
            refundOptionsCategoryOptions,
        } = refundCategory;

        const refundOptionsList = Object.entries(refundOptionsCategoryOptions).map(([refundOptionId, refundOptionName]) => {
            return (
                <CheckboxFieldComponent
                    key={refundOptionId}
                    checkboxLabel={refundOptionName}
                    checkboxCheckedStatus={checkedRefundOptions.has(+refundOptionId)}
                    checkboxCheckedStatusHandler={() => refundOptionCheckedStatusHandler(+refundOptionId)}
                />
            );
        });

        return (
            <Col key={refundOptionsCategoryId} xs={12} className={'user-dashboard-submit-request-refund-options'}>
                <Row className={'user-dashboard-submit-request-refund-options__options-container'}>
                    <Col xs={12} className={'user-dashboard-submit-request-refund-options__options-header'} onClick={() => activeRefundCategoryId === refundOptionsCategoryId ? setActiveRefundCategoryId(0) : setActiveRefundCategoryId(refundOptionsCategoryId)}>
                        <SvgIconComponent iconSource={refundOptionsCategoryIcon} className={'user-dashboard-submit-request-refund-options__options-header__header-icon'} />
                        <span className={'user-dashboard-submit-request-refund-options__options-header__header-title'}>{refundOptionsCategoryName}</span>
                        <SvgIconComponent iconSource={activeRefundCategoryId === refundOptionsCategoryId ? IconArrowUpSmGrey : IconArrowDownSmGrey} className={'user-dashboard-submit-request-refund-options__options-header__header-switcher-icon'} />
                    </Col>
                    {activeRefundCategoryId === refundOptionsCategoryId &&
                    <Col xs={12} className={'user-dashboard-submit-request-refund-options__options-list'}>
                        <Row className={'user-dashboard-submit-request-refund-options__options-list__list-content'}>
                            {refundOptionsList}
                        </Row>
                    </Col>
                    }
                </Row>
            </Col>
        );

    });


    return (
        <Col xs={12} className={'user-dashboard-submit-request-step'}>
            <Row className={'user-dashboard-submit-request-step__step-content'}>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>
                    <span className={'user-dashboard-submit-request-step__step-header__main-header'}>Type of Refund Request</span>
                    <span className={'user-dashboard-submit-request-step__step-header__sub-header'}>Select the type of refund you are seeking</span>
                </Col>

                <Col xs={12} className={'user-dashboard-submit-request-step__step-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-content'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Select the type of refund you are seeking</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-description'}>
                            <span>Chose at least 1 refund request</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                {refundOptionsCategoriesList}
                            </Row>
                        </Col>
                    </Row>
                </Col>

                {/*{refundOptionsCategoriesList}*/}

                <Col className={'user-dashboard-submit-request-step__step-buttons'}>
                    <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content'}>
                        <ButtonComponent
                            size={'l'} type={'flat'}
                            text={'Back'} iconLeft={IconArrowLeftSmBrown}
                            callback={() => userSubmitRequestStepSetter(0)}
                        />
                        <ButtonComponent
                            size={'l'}
                            text={'Next Step'} iconRight={IconArrowRightSmBrown}
                            callback={() => userSubmitRequestStepSetter(2)}
                            buttonDisabled={!storedRefundOptions.length}
                        />
                    </Row>
                </Col>
            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStep1Component;
